import { CurrencyUtil, Logger, LogManager, ModelRow, StringUtil, DateUtil } from ".";

export type SortDirection = "asc" | "desc";

export class SortUtil {
    private static log: Logger;

    public static getSortTestValue(data: ModelRow | any, fieldName: string): any {
        if (data instanceof ModelRow) {
            if (data.isNull(fieldName))
                return null;
            return data.getTypedDataValue(fieldName);
        }
        return data.data[fieldName];
    }

    public static compareTwoValues(valueA: any, valueB: any, sortMethod: SortDirection = "asc",
        sortNullsAtEnd = false): number {
        const log = this.getLog();
        log.debug("Sort: %o  Test Value A: [%o]  Test Value B: [%o]", sortMethod, valueA, valueB);
        let result = 0;
        if (valueA == valueB) {
            result = 0;
        } else if (valueA == null) {
            result = sortNullsAtEnd ? 1 : -1;
        } else if (valueB == null) {
            result = sortNullsAtEnd ? -1 : 1;
        } else if (CurrencyUtil.isCurrency(valueA) && CurrencyUtil.isCurrency(valueB)) {
            result = CurrencyUtil.compareCurrencies(valueA, valueB);
        } else if (valueA instanceof Date && valueB instanceof Date && DateUtil.datesEqual(valueA, valueB)) {
            result = 0;
        } else if (typeof valueA === 'string' && typeof valueB === 'string') {
            result = StringUtil.compare(valueA, valueB);
        } else {
            result = valueA > valueB ? 1 : -1;
        }

        if (result != 0 && sortMethod === "desc") {
            result *= -1;
        }
        log.debug("Sort result: %d", result);
        return result;
    }

    private static getLog(): Logger {
        if (this.log == null)
            this.log = LogManager.getLogger("core.SortUtil");
        return this.log;
    }
}
